import { setLocalStorageItem } from '@Builder/QuoteDetailPage/logic'
import {
    SELECTED_SHIPPING_OPTION_PREFIX,
    SELECTED_SHIPPING_ADDRESS_ID_PREFIX,
} from '@Builder/QuoteDetailPage/QuoteDetailsSummaryCard/components/ShippingSection/constants'

import {
    SET_QUOTE_IS_FREIGHT_SHIPPING,
    SET_QUOTE_IS_LOADING,
    SET_QUOTE_IS_TAX_EXEMPT,
    SET_QUOTE_SHIPPING_OPTIONS_IS_LOADING,
    SET_SELECTED_SHIPPING_ADDRESS,
    SET_SELECTED_SHIPPING_OPTION,
    SET_LINE_QUANTITY_ERROR,
    UPDATE_LINE_QUANTITY_ERROR_IDS,
    SET_MAX_LEAD_TIME_DAYS,
} from './constants'
import { ActionType, QuoteDetailType } from './types'

type StateType = {
    [key: string]: QuoteDetailType
}

const INIT_STATE: StateType = {}

export default function reducer(state = INIT_STATE, action: ActionType) {
    const {
        type,
        quoteId,
        isLoading,
        isShippingOptionsLoading,
        isFreightShipping,
        isTaxExempt,
        maxLeadTimeDays,
        selectedShippingAddressId,
        selectedShippingOption,
        quantityError,
    } = action
    const quoteDetail = { ...state[quoteId] } || {}

    switch (type) {
        case SET_QUOTE_IS_LOADING:
            quoteDetail.isLoading = isLoading
            return { ...state, [quoteId]: quoteDetail }

        case SET_SELECTED_SHIPPING_ADDRESS:
            if (quoteId) {
                setLocalStorageItem(
                    `${SELECTED_SHIPPING_ADDRESS_ID_PREFIX}${quoteId}`,
                    selectedShippingAddressId || '',
                )
            }
            quoteDetail.selectedShippingAddressId = selectedShippingAddressId
            return {
                ...state,
                [quoteId]: quoteDetail,
            }

        case SET_SELECTED_SHIPPING_OPTION:
            setLocalStorageItem(
                `${SELECTED_SHIPPING_OPTION_PREFIX}${quoteId}`,
                selectedShippingOption?.id || '',
            )
            quoteDetail.selectedShippingOption = selectedShippingOption
            return { ...state, [quoteId]: quoteDetail }

        case SET_QUOTE_IS_FREIGHT_SHIPPING:
            quoteDetail.isFreightShipping = isFreightShipping
            return { ...state, [quoteId]: quoteDetail }

        case SET_QUOTE_SHIPPING_OPTIONS_IS_LOADING:
            quoteDetail.isShippingOptionsLoading = isShippingOptionsLoading
            return { ...state, [quoteId]: quoteDetail }

        case SET_QUOTE_IS_TAX_EXEMPT:
            quoteDetail.isTaxExempt = isTaxExempt
            return { ...state, [quoteId]: quoteDetail }

        case SET_LINE_QUANTITY_ERROR: {
            return {
                ...state,
                [quoteId]: {
                    ...quoteDetail,
                    lineQuantityErrors: {
                        ...(quoteDetail?.lineQuantityErrors ?? {}),
                        // This is angry because this is possibly undefined, but not
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        [quantityError.lineId]: quantityError.error,
                    },
                },
            }
        }

        // For IM-1200. Accepts array of qmr ids and removes any properties
        // not in the lineQuantityErrors object
        case UPDATE_LINE_QUANTITY_ERROR_IDS: {
            const missingIds = Object.keys(
                quoteDetail?.lineQuantityErrors ?? {},
            ).filter(qmrId => !action.availableQmrIds?.includes(qmrId))

            // Nothing was removed, no need to cause re-renders
            if (!missingIds.length) {
                return state
            }

            const newLineQuantityErrors = {
                ...state?.quoteId?.lineQuantityErrors,
            }

            missingIds.forEach(
                (qmrId: string) => delete newLineQuantityErrors[qmrId],
            )

            return {
                ...state,
                [quoteId]: {
                    ...quoteDetail,
                    lineQuantityErrors: newLineQuantityErrors,
                },
            }
        }

        case SET_MAX_LEAD_TIME_DAYS: {
            return {
                ...state,
                [quoteId]: {
                    ...quoteDetail,
                    maxLeadTimeDays,
                },
            }
        }

        default:
            return state
    }
}
